"use client"

import { useState, useRef, useEffect } from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { registerCompany } from "../api/companyApi"
import { getAllCurrencies } from "../api/currencyService"
import Swal from "sweetalert2"
import { FaEye, FaEyeSlash } from "react-icons/fa"

const initialFormData = {
  companyName: "",
  // registrationNumber: "",
  loginEmail: "",
  password: "",
  dateEstablished: "",
  address: "",
  city: "",
  country: "",
  postalCode: "",
  mainPhoneNumber: "",
  emailAddress: "",
  website: "",
  defaultCurrency: "USD",
  // operatingPorts: [],
  workingHours: "",
  whoWeAre: "",
  vision: "",
  mission: "",
  purpose: "",
  facebookUrl: "",
  instagramUrl: "",
  whatsappNumber: "",
  linkedinProfile: "",
  skypeId: "",
}

const CompanyRegistration = () => {
  const [formData, setFormData] = useState(initialFormData)
  const [logo, setLogo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [currencies, setCurrencies] = useState([])
  const [loadingCurrencies, setLoadingCurrencies] = useState(true)
  const [countries, setCountries] = useState([])

  const dateInputRef = useRef(null)

  useEffect(() => {
    const fetchCurrencies = async () => {
      setLoadingCurrencies(true)
      try {
        const currencyList = await getAllCurrencies()
        if (currencyList && currencyList.length > 0) {
          setCurrencies(currencyList)
          const uniqueCountries = [...new Set(currencyList.map((c) => c.countryName).filter(Boolean))].sort()
          setCountries(uniqueCountries)
        } else {
          // Fallback if API fails or returns empty
          console.warn("[v0] No currencies found, using defaults")
        }
      } catch (error) {
        console.error("[v0] Failed to load currencies:", error)
      } finally {
        setLoadingCurrencies(false)
      }
    }

    fetchCurrencies()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target

    if (name === "country" && value) {
      const matchingCurrency = currencies.find((c) => c.countryName === value)
      if (matchingCurrency) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          defaultCurrency: matchingCurrency.code,
        }))
        return
      }
    }

    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handlePortsChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value)
    setFormData((prev) => ({ ...prev, operatingPorts: selectedOptions }))
  }

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setLogo(e.target.files[0])
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const data = await registerCompany(formData, logo)

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "Registration Successful!",
          text: data.message || "Company has been registered successfully.",
          confirmButtonColor: "#004aad",
        })
        setFormData(initialFormData)
        setLogo(null)
      } else {
        Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text: data.message || "Something went wrong. Please try again.",
          confirmButtonColor: "#004aad",
        })
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Unable to connect to the server. Please try again later.",
        confirmButtonColor: "#004aad",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Header />

      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n  \n    .contact-header {\n      text-align: center;\n      padding: 60px 20px 40px;\n    }\n    .contact-header h1 {\n      font-weight: 800;\n      color: #002b5c;\n    }\n    .contact-header p {\n      color: #6c757d;\n    }\n    .contact-card {\n      background:  var(--info-card);\n      border-radius: 16px;\n      padding: 30px;\n      box-shadow: rgba(0, 0, 0, 0.08) 0px 6px 20px;\n      height: 100%;\n    }\n    \n    .info-box {\n      display: flex;\n      align-items: start;\n      margin-bottom: 20px;\n    }\n    .info-box i {\n      font-size: 1.6rem;\n      margin-right: 15px;\n      color: #004aad;\n    }\n    iframe {\n      border-radius: 16px;\n    }\n\n    \n    \n  ",
        }}
      />
      {/* HERO */}
      <section className="hero1" style={{ marginTop: 80 }}>
        <div className="container-lg">
          <div className="row g-3 justify-content-center">
            <div className="col-lg-8 py-4">
              <h3 style={{ textTransform: "uppercase" }} className="fw-bold">
                Company Registration
              </h3>
            </div>
          </div>
        </div>
      </section>
      <section className="features py-5">
        <div className="container-lg">
          <div className="row g-4 justify-content-center">
            {/* Contact Form */}
            <div className="col-lg-10">
              <div className="contact-card destination">
                <h4 className="fw-bold mb-3">Company Register</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    {/* Basic Company Info */}
                    <div className="col-md-12">
                      <div className="">
                        <div className="card-header border-bottom pb-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title">Basic Company Information</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter company name"
                              name="companyName"
                              value={formData.companyName}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Login Email</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Enter login email"
                              name="loginEmail"
                              value={formData.loginEmail}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Password</label>
                            <div style={{ position: "relative" }}>
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                placeholder="Enter password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                style={{ paddingRight: "40px" }}
                              />
                              <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#6c757d",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Logo</label>
                            <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Date Established</label>
                            <div style={{ position: "relative" }}>
                              <input
                                type="date"
                                className="form-control"
                                name="dateEstablished"
                                value={formData.dateEstablished}
                                onChange={handleChange}
                                ref={dateInputRef}
                                style={{ paddingRight: "40px" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Contact Details */}
                    <div className="col-md-12">
                      <div className="">
                        <div className="card-header border-bottom pb-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title">Contact Details</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Address</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Street Address"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <label className="form-label">City</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label">Country</label>
                              <select
                                className="form-select"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                disabled={loadingCurrencies || countries.length === 0}
                              >
                                <option value="">Select a country</option>
                                {countries.map((country) => (
                                  <option key={country} value={country}>
                                    {country}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Postal Code</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Postal Code"
                              name="postalCode"
                              value={formData.postalCode}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Main Phone Number</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="+1 234 567 890"
                              name="mainPhoneNumber"
                              value={formData.mainPhoneNumber}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="example@email.com"
                              name="emailAddress"
                              value={formData.emailAddress}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Operational Details */}
                    <div className="col-md-12">
                      <div className="">
                        <div className="card-header border-bottom pb-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title">Operational Details</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Default Currency</label>
                            <select
                              className="form-select"
                              name="defaultCurrency"
                              value={formData.defaultCurrency}
                              onChange={handleChange}
                              disabled={loadingCurrencies || currencies.length === 0}
                            >
                              {loadingCurrencies ? (
                                <option>Loading currencies...</option>
                              ) : currencies.length === 0 ? (
                                <option>No currencies available</option>
                              ) : (
                                currencies.map((currency) => (
                                  <option key={currency.code} value={currency.code}>
                                    {currency.code} - {currency.name}
                                  </option>
                                ))
                              )}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Working Hours</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Mon-Fri, 9am-5pm"
                              name="workingHours"
                              value={formData.workingHours}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* About Us */}
                    <div className="col-md-12">
                      <div className="">
                        <div className="card-header border-bottom pb-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title">About Us</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Who We Are</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Description"
                              name="whoWeAre"
                              value={formData.whoWeAre}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Vision</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Our vision"
                              name="vision"
                              value={formData.vision}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Mission</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Our mission"
                              name="mission"
                              value={formData.mission}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Purpose</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Our purpose"
                              name="purpose"
                              value={formData.purpose}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Social Network Links */}
                    <div className="col-md-12">
                      <div className="">
                        <div className="card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title">Social Network Links</h5>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Facebook</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Facebook URL"
                              name="facebookUrl"
                              value={formData.facebookUrl}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Instagram</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Instagram URL"
                              name="instagramUrl"
                              value={formData.instagramUrl}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">WhatsApp</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="WhatsApp Number"
                              name="whatsappNumber"
                              value={formData.whatsappNumber}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">LinkedIn</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="LinkedIn Profile"
                              name="linkedinProfile"
                              value={formData.linkedinProfile}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Skype</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Skype ID"
                              name="skypeId"
                              value={formData.skypeId}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary-navy w-100"
                        disabled={loading}
                        style={{
                          padding: "12px 24px",
                          fontSize: "16px",
                          fontWeight: "600",
                          borderRadius: "8px",
                        }}
                      >
                        {loading ? "Registering..." : "Register Now"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default CompanyRegistration
